export default __webpack_public_path__ + "static/media/38.85b8a972.svg";